import React, { useState } from "react";
import headerBg from "./assets/picOne.png";

const ComplaintsHandling = () => {
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    email: "",
    organization: "",
    postal: "",
    department: "",
    type: "",
    details: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const subject = encodeURIComponent("Customer Feedback / Complaint Form Submission");
    const body = encodeURIComponent(
      `Customer Name: ${formData.name}\nTelephone/Mobile: ${formData.phone}\nEmail: ${formData.email}\nOrganization: ${formData.organization}\nPostal Address: ${formData.postal}\nDepartment: ${formData.department}\nType of Feedback: ${formData.type}\nDetails:\n${formData.details}`
    );
    window.location.href = `mailto:info@mbs.mw?subject=${subject}&body=${body}`;
  };

  return (
    <div style={{ fontFamily: "'Inter', sans-serif", background: "#f7f7f8" }}>
      {/* === Overlay Header === */}
      <section
        style={{
          backgroundImage: `url(${headerBg})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          padding: "130px 20px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div
          style={{
            background: "rgba(0,0,0,0.55)",
            padding: "50px 40px",
            textAlign: "center",
            color: "white",
            width: "90%",
            maxWidth: "1100px",
            borderRadius: "14px",
            borderLeft: "5px solid #ff6600",
            borderRight: "5px solid #ff6600",
            boxShadow: "0px 8px 20px rgba(0,0,0,0.4)",
          }}
        >
          <h1 style={{ fontSize: "44px", marginBottom: "10px", fontWeight: "700" }}>
            Customer Feedback / Complaint Form
          </h1>
          <p style={{ fontSize: "18px", opacity: "0.9" }}>
            Share your feedback or complaint with the Malawi Bureau of Standards. All submissions are handled confidentially.
          </p>
        </div>
      </section>

      {/* === Form Section === */}
      <section style={{ padding: "50px 20px", display: "flex", justifyContent: "center" }}>
        <form
          onSubmit={handleSubmit}
          style={{
            background: "#fff",
            padding: "50px",
            borderRadius: "14px",
            maxWidth: "900px",
            width: "100%",
            boxShadow: "0 12px 30px rgba(0,0,0,0.12)",
            display: "flex",
            flexDirection: "column",
            gap: "22px",
          }}
        >
          {/* Portal Info First */}
          <p style={{ fontSize: "16px", color: "#333", marginBottom: "20px", fontWeight: "600" }}>
            You can also submit and track queries via the portal:{" "}
            <a
              href="http://192.168.0.5:7006/login"
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: "#ff6600", textDecoration: "underline" }}
            >
              http://192.168.0.5:7006/login
            </a>
          </p>

          {/* Form Title */}
          <h2 style={{ fontSize: "28px", fontWeight: "700", color: "#222", marginBottom: "10px", textAlign: "center" }}>
            Customer Feedback / Complaint Form
          </h2>

          {/* Customer Name */}
          <label style={labelStyle}>Customer Name
            <input type="text" name="name" value={formData.name} onChange={handleChange} required style={inputStyle} />
          </label>

          {/* Phone */}
          <label style={labelStyle}>Telephone / Mobile Number
            <input type="text" name="phone" value={formData.phone} onChange={handleChange} required style={inputStyle} />
          </label>

          {/* Email */}
          <label style={labelStyle}>Your Email Address
            <input type="email" name="email" value={formData.email} onChange={handleChange} required style={inputStyle} />
          </label>

          {/* Organization */}
          <label style={labelStyle}>Organization
            <input type="text" name="organization" value={formData.organization} onChange={handleChange} style={inputStyle} />
          </label>

          {/* Postal Address */}
          <label style={labelStyle}>Postal Address
            <input type="text" name="postal" value={formData.postal} onChange={handleChange} style={inputStyle} />
          </label>

          {/* Department */}
          <label style={labelStyle}>Department (select one)
            <select name="department" value={formData.department} onChange={handleChange} required style={inputStyle}>
              <option value="">—Please choose an option—</option>
              <option value="Standard Development">Standards Development</option>
              <option value="Quality Assurance and Services">Quality Assurance and Services Department</option>
              <option value="Testing Services">Testing Services Department</option>
              <option value="Metrology Services">Metrology Services Department</option>
              <option value="Director Genral">Director General Office</option> 
              <option value="Human Resources and Administration">Human Resources and Administration Department</option>
              <option value="Finance Department">Finance Department</option>
              
            </select>
          </label>

          {/* Feedback Type */}
          <label style={labelStyle}>Type of Feedback (select one)
            <select name="type" value={formData.type} onChange={handleChange} required style={inputStyle}>
              <option value="">—Please choose an option—</option>
              <option value="Complaint">Complaint</option>
              <option value="Compliment">Compliment</option>
              <option value="Appeal">Appeal</option>
              <option value="Follow-up">Follow-up</option>
            </select>
          </label>

          {/* Details */}
          <label style={labelStyle}>Details
            <textarea name="details" value={formData.details} onChange={handleChange} required style={{ ...inputStyle, height: "160px", resize: "vertical" }} />
          </label>

          {/* Submit */}
          <button type="submit" style={buttonStyle}>Submit Feedback</button>
        </form>
      </section>
    </div>
  );
};

const labelStyle = {
  fontWeight: "600",
  fontSize: "15px",
  color: "#222",
};

const inputStyle = {
  width: "100%",
  padding: "14px 16px",
  marginTop: "6px",
  borderRadius: "10px",
  border: "1px solid #ddd",
  fontSize: "15px",
  boxSizing: "border-box",
};

const buttonStyle = {
  background: "#ff6600",
  color: "#fff",
  fontWeight: "700",
  padding: "16px",
  borderRadius: "12px",
  border: "none",
  cursor: "pointer",
  fontSize: "16px",
  marginTop: "10px",
  transition: "0.3s",
};

export default ComplaintsHandling;
